
import { defineComponent, ref, reactive, toRefs, onMounted, watch, nextTick, computed } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import f10Api from '@/api/f10Api'
import Table from '@/components/table.vue'
import Drawer from '@/components/drawer.vue'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    currentsharesData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: { Table, Drawer, Charts, Nodata },
  setup(props, context) {
    const pageData: any = reactive({
      data: [],
      data2: [],
      columns: [],
      columns2: [],
      radiovalue: '',
      radiolist: [],
      pagination: {
        showSizeChanger: true,
        showTotal: (total: any) => `共${total}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        showQuickJumper: true,
        onChange: changesize
      },
      drawerdata: {},
      optiongd_detail: {},
      visible: false,
      Controller: '',
      IsStib: 2,
      spinning: true,
      total2: 0,
      currentshareholder: {},
      pagination2: {},
      getContainer: () => document.querySelector('.hashwrapper')
    })

    pageData.pagination2 = computed(() => {
      return {
        total: pageData.total2,
        showSizeChanger: true,
        showTotal: (total: any) => `共${pageData.total2}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        onChange: changesize,
        onShowSizeChange: changesize
      }
    })
    const color = globalsets.getColor()
    pageData.columns = [
      {
        title: '名次',
        dataIndex: 'Rank',
        key: 'Rank',
        width: '50px',
        slots: { customRender: 'spotColor' }
      },
      {
        title: '股东名称',
        dataIndex: 'SHName',
        key: 'SHName',
        width: '180px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '股东性质',
        dataIndex: 'SHNature',
        key: 'SHNature',
        width: '110px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '股份类型',
        dataIndex: 'ShareType',
        key: 'ShareType',
        width: '110px',
        ellipsis: true,
        slots: { customRender: 'ellipsis' }
      },
      {
        title: '持股数(股)',
        dataIndex: 'HoldSum',
        key: 'HoldSum',
        width: '90px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占总股本比例',
        dataIndex: 'PCTOfTotalShares',
        key: 'PCTOfTotalShares',
        width: '100px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '增减(股)',
        dataIndex: 'IncreaseOrReduce',
        key: 'IncreaseOrReduce',
        width: '85px',
        slots: { customRender: 'peopleCountColor' }
      },
      {
        title: '变动比例',
        dataIndex: 'ChangeRatio',
        key: 'ChangeRatio',
        width: '100px',
        slots: { customRender: 'increase' }
      }
    ]

    pageData.columns2 = [
      {
        title: '报告期',
        dataIndex: 'time',
        key: 'time',
        width: '100px'
      },
      {
        title: '持股数(股)',
        dataIndex: 'HoldSum',
        key: 'HoldSum',
        width: '100px',
        slots: { customRender: 'peopleCount' }
      },
      {
        title: '占总股本比例',
        dataIndex: 'PCTOfTotalShares',
        key: 'PCTOfTotalShares',
        width: '120px',
        slots: { customRender: 'nocolorincrease' }
      },
      {
        title: '增减(股)',
        dataIndex: 'IncreaseOrReduce',
        key: 'IncreaseOrReduce',
        width: '100px',
        slots: { customRender: 'peopleCountColor' }
      }
    ]
    // 显示抽屉
    const route = useRoute()
    function showdrawer(PageID: number, PageSize: number, data: any) {
      pageData.visible = true
      if (data) {
        pageData.currentshareholder = Object.assign(data.record, props.currentsharesData)
      }
      getData2(PageID, PageSize)
    }
    function changesize(obj: any) {
      getData2(obj.PageID, obj.PageSize)
    }
    function onClose() {
      pageData.visible = false
    }
    function getData2(PageID: number, PageSize: number) {
      const _data: any = {}
      _data.data = {
        Inst: route.query.code,
        Exch: route.query.market,
        PageID: PageID,
        Tp: 1,
        PageSize: PageSize,
        Name: pageData.currentshareholder.SHName
      }
      _data.headers = {
        token: props.token
      }
      f10Api.getholderholdestockhis(_data).then((res: any) => {
        pageData.drawerdata = res.Data
        const data = JSON.parse(JSON.stringify(res.Data))
        if (data && (data.Detail || []).length) {
          data.Detail.forEach((item: any, i: number) => {
            item.index = 'holdestockhis2' + i
            item.timer = 'holdestockhis2' + i + new Date().getTime()
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
        }
        pageData.total2 = data.Total
        pageData.data2 = data.Detail
        nextTick(() => {
          setgdDetail()
        })
      })
    }
    function setgdDetail() {
      // optiongd_detail
      const data = JSON.parse(JSON.stringify(pageData.drawerdata)).Detail
      if (!data || !data.length) return
      const xAxis = data.map((item: any) => window.moment(item.EndDate * 1000).format('YYYY-MM-DD')).reverse()

      const arr1 = data.map((item: any) => item.HoldSum)
      const arr2 = data.map((item: any) => item.PCTOfTotalShares)

      const max1 = Math.max.apply(null, arr1)
      const max2 = Math.max.apply(null, arr2)
      data.map((item: any) => {
        return parseFloat(item.PCTOfTotalShares).toString() !== 'NaN' ? item.PCTOfTotalShares.toFixed(2) : null
      })
      pageData.optiongd_detail = {
        color: color,
        tooltip: {
          trigger: 'axis',
          formatter: function(params: any) {
            var htmlStr = ''
            htmlStr += '<div style="font-size: 12px;"><p style="color:rgba(0,0,0,0.45);margin-bottom: 8px">' + params[0].name + '</p>'
            for (var i = 0; i < params.length; i++) {
              // 前面的原点和他的颜色
              let value = String(globalsets.getNumber(params[i].value))
              let style = 'height: 8px;'
              if (i === 1) {
                value = value + '%'
                style = 'height: 2px;'
              }
              htmlStr +=
                '<span style="width: 8px;' +
                style +
                'vertical-align: middle;display:inline-block;margn-right: 4px;background-color:' +
                params[i].color +
                '"></span><span style="color:#000;margin-left: 6px;">' +
                params[i].seriesName +
                ':</span>' +
                '<span style="color:#000;float:right;margin-left: 12px">' +
                value +
                '</span><br/>'
            }
            htmlStr += '</div>'
            return htmlStr
          }
        },
        grid: [
          {
            top: 40,
            left: 10,
            right: 10,
            bottom: 50,
            containLabel: true
          }
        ],
        toolbox: {
          feature: {}
        },
        legend: [
          {
            bottom: 20,
            itemWidth: 8,
            left: '188',
            itemHeight: 8,
            data: [
              {
                name: '持股数（股）', // 图例文字内容
                icon: 'rect',
                textStyle: {
                  color: '#7D7D7D'
                }
              }
            ]
          },
          {
            bottom: 20,
            itemWidth: 8,
            left: '288',
            itemHeight: 2,
            data: [
              {
                name: '持股比例', // 图例文字内容
                icon: 'rect',
                textStyle: {
                  color: '#7D7D7D'
                }
              }
            ]
          }
        ],
        xAxis: [
          {
            type: 'category',
            data: xAxis,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            name: '持股数（股）',
            type: 'value',
            interval: Math.ceil(Math.ceil(max1) / 5),
            max: Math.ceil(Math.ceil(max1) / 5) * 5
          },
          {
            name: '持股比例',
            type: 'value',
            interval: Math.ceil(Math.ceil(max2) / 5),
            max: Math.ceil(Math.ceil(max2) / 5) * 5,
            axisLabel: {
              formatter: function(value: any) {
                return (value || 0).toFixed(2) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '持股数（股）',
            type: 'bar',
            yAxisIndex: 0,
            barWidth: 20,
            data: data.map((item: any) => item.HoldSum).reverse()
          },
          {
            name: '持股比例',
            type: 'line',
            yAxisIndex: 1,
            lineStyle: {
              width: 1
            },
            data: data.map((item: any) => (parseFloat(item.PCTOfTotalShares).toString() !== 'NaN' ? item.PCTOfTotalShares.toFixed(2) : null)).reverse()
          }
        ]
      }
    }
    function setData() {
      const data = JSON.parse(JSON.stringify((props.pageSourceData || {}).TopTenSH)).Detail
      const currentdata: any = data.filter((item: any) => window.moment(item.EndDate * 1000).format('YYYY-MM-DD') === pageData.radiovalue)
      const _data = currentdata[0].ShareholderList
      _data.forEach((item: any, i: number) => {
        item.index = 'TopTenSH' + i
      })
      _data.push(currentdata[0].Summary)
      _data[_data.length - 1].index = 'TopTenSH11'
      pageData.data = _data
    }
    function changeradio() {
      setData()
    }
    watch(
      () => (props.pageSourceData || {}).TopTenSH,
      (val: any) => {
        const data = JSON.parse(JSON.stringify(val.Detail))
        if ((data || []).length) {
          pageData.radiolist = data.map((item: any) => window.moment(item.EndDate * 1000).format('YYYY-MM-DD'))
          pageData.radiovalue = pageData.radiolist[0]
          pageData.Controller = (props.pageSourceData || {}).TopTenSH.Controller
          pageData.IsStib = (props.pageSourceData || {}).TopTenSH.IsStib
          setData()
        }
        nextTick(() => {
          pageData.spinning = false
        })
      },
      { deep: true }
    )
    return {
      ...toRefs(pageData),
      changesize,
      showdrawer,
      onClose,
      changeradio
    }
  }
})
